import { Link } from "react-router-dom";
import { Lock } from "lucide-react";
import { CourseEligibility } from "types";
import { courseUrl } from "./coursePresentation";

export function CourseRequirements({
  eligibility,
  compact = false,
}: {
  eligibility: CourseEligibility;
  compact?: boolean;
}) {
  const requirements = eligibility.unmet_prerequisites;
  if (!requirements.length) return null;
  return (
    <section
      className={`course-requirements${compact ? " is-compact" : ""}`}
      aria-label="Course prerequisites"
    >
      {!compact && <h2><Lock size={20} aria-hidden="true" />Before you begin</h2>}
      <p>
        Complete {requirements.length === 1 ? "the course" : "the courses"} below
        before beginning.
      </p>
      <ul>
        {requirements.map((item) => (
          <li key={item.id}>
            <div className="requirement-detail">
              <strong>{item.name}</strong>
            </div>
            {item.is_assigned && item.is_active !== false && (
              <Link className="course-text-link" to={courseUrl(item.id)}>
                View course
                <span className="sr-only">: {item.name}</span>
              </Link>
            )}
          </li>
        ))}
      </ul>
      {requirements.some(
        (item) =>
          !item.is_completed &&
          (!item.is_assigned || item.is_active === false),
      ) && (
        <p className="course-guidance">
          A prerequisite isn’t available to you yet. Ask your organization
          administrator or mentor for access.
        </p>
      )}
    </section>
  );
}
